import { AcroLevel, JudgeType, Judge, User, PanelJudge, JudgingPanel } from '@vote4dance/judging-schema';
import { CompetitionId, JudgeId, PanelId, RoundId } from '@vote4dance/judging-types';
import { StreamSource } from "../hooks/streams";

export type JudgeItem = Judge
& Pick<User, 'user_firstname' | 'user_lastname'>
& {
    judge_type: JudgeType,
    judge_pin_created: boolean
}

export type PanelJudgeItem = PanelJudge & JudgeItem;

export type JudgingPanelItem = JudgingPanel
& {
    panel_locked: number,
    judge_count: number
}

type JudgeItemCompanion = {
    getFullName(judge: JudgeItem): string
}

export const JudgeItem: JudgeItemCompanion = {
    getFullName(judge: JudgeItem): string {
        return judge.user_firstname + ' ' + judge.user_lastname;
    }
}

export function JudgingPanelSource(competition_id: CompetitionId) {
    return new StreamSource<JudgingPanelItem[]>(`/judging-panels/${competition_id}`);
}

export function PanelJudgeSource(competition_id: CompetitionId, panel_id: PanelId) {
    return new StreamSource<PanelJudgeItem[]>(`/panel-judges/${competition_id}/${panel_id}`);
}

export function JudgeSource(competition_id: CompetitionId) {
    return new StreamSource<JudgeItem[]>(`/judges/${competition_id}`);
}

export function RoundJudgeSource(competition_id: CompetitionId, round_id: RoundId) {
    return new StreamSource<JudgeItem[]>(`/round-judges/${competition_id}/${round_id}`);
}

export function JudgeClassesSource(competition_id: CompetitionId, judge_id: JudgeId) {
    return new StreamSource<JudgeItem[]>(`/judge-classes/${competition_id}/${judge_id}`);
}

export function AcroLevelSource() {
    return new StreamSource<AcroLevel[]>(`/acrolevels`);
}
